import { z } from 'zod';

export const mapsetSettingsSchema = z.object({
  maxMapSetAssignments: z.number(),
});

export type MapsetSettings = z.infer<typeof mapsetSettingsSchema>;
